/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ChoreographerListItem
 */
export interface ChoreographerListItem {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ChoreographerListItem
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChoreographerListItem
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    contractSignedName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ChoreographerListItem
     */
    contractSignedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    contractVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChoreographerListItem
     */
    engagement: string;
}

/**
 * Check if a given object implements the ChoreographerListItem interface.
 */
export function instanceOfChoreographerListItem(value: object): value is ChoreographerListItem {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('contractSignedName' in value) || value['contractSignedName'] === undefined) return false;
    if (!('contractSignedAt' in value) || value['contractSignedAt'] === undefined) return false;
    if (!('contractVersion' in value) || value['contractVersion'] === undefined) return false;
    if (!('engagement' in value) || value['engagement'] === undefined) return false;
    return true;
}

export function ChoreographerListItemFromJSON(json: any): ChoreographerListItem {
    return ChoreographerListItemFromJSONTyped(json, false);
}

export function ChoreographerListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChoreographerListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'isActive': json['isActive'],
        'contractSignedName': json['contractSignedName'],
        'contractSignedAt': (json['contractSignedAt'] == null ? null : new Date(json['contractSignedAt'])),
        'contractVersion': json['contractVersion'],
        'engagement': json['engagement'],
    };
}

export function ChoreographerListItemToJSON(json: any): ChoreographerListItem {
    return ChoreographerListItemToJSONTyped(json, false);
}

export function ChoreographerListItemToJSONTyped(value?: ChoreographerListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'isActive': value['isActive'],
        'contractSignedName': value['contractSignedName'],
        'contractSignedAt': value['contractSignedAt'] == null ? value['contractSignedAt'] : value['contractSignedAt'].toISOString(),
        'contractVersion': value['contractVersion'],
        'engagement': value['engagement'],
    };
}

